import { render, staticRenderFns } from "./Section8thIm.vue?vue&type=template&id=35570794&scoped=true&"
import script from "./Section8thIm.vue?vue&type=script&lang=js&"
export * from "./Section8thIm.vue?vue&type=script&lang=js&"
import style0 from "./Section8thIm.vue?vue&type=style&index=0&id=35570794&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35570794",
  null
  
)

export default component.exports